const stringsToOptions = (strings: string[]) => strings.map((str) => ({
  label: str,
  value: str,
}));

export default stringsToOptions;
